import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
  Toast,
  ToastContainer,
} from 'react-bootstrap';
import { FaFileDownload } from 'react-icons/fa';
import axios from 'axios';
import Select from 'react-select';
import { useAuth } from "../../contexts/AuthContext";



const PolicyGeneratorTab = ({ userData,logToAccessLogs }) => {
  const [form, setForm] = useState({
    orgName: '',
    industry: '',
    location: '',
    activities: [],
    policyTypes: [],
    customIndustry: '',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: '' });
  const [generatedPolicies, setGeneratedPolicies] = useState([]);
const { profile } = useAuth();
   const organizationId = profile?.orgId;
  const ACTIVITY_OPTIONS = [
  { value: 'Customer Management', label: 'Customer Management' },
  { value: 'Marketing & Analytics', label: 'Marketing & Analytics' },
  { value: 'Employee Records', label: 'Employee Records' },
  { value: 'Financial Transactions', label: 'Financial Transactions' },
  { value: 'Website Analytics', label: 'Website Analytics' },
];

  const getUserRegion = () => sessionStorage.getItem('userRegion') || 'AP';

 

  const handleReset = () => {
  setForm({
    orgName: '',
    industry: '',
    location: '',
    activities: [],
    policyTypes: [],
     customIndustry: '',
  });
  setGeneratedPolicies([]);
};

const handlePreview = async () => {
  if (form.policyTypes.length === 0) {
    showToast('Select at least one policy to preview.', 'warning');
    return;
  }

  const previewType = form.policyTypes[0];
  const typeSlug = previewType.toLowerCase().replace(/\s+/g, '-');
  try {
    const res = await axios.get(`https://vy0wcdsuaf.execute-api.ap-southeast-2.amazonaws.com/prod/api/generate-policy/sample/${typeSlug}`, {
      responseType: 'blob'
    });

    const file = new Blob([res.data], { type: 'text/plain' });
    const url = URL.createObjectURL(file);
    window.open(url, '_blank');
    await logActivity(`Previewed ${previewType} sample policy`, "info");
    logToAccessLogs?.({
  action:      'Policy Previewed',
  severity:    'info',
  description: `Previewed sample policy: ${previewType}`,});

    
  } catch (err) {
    showToast('Error previewing policy', 'danger');
  }
};



  const showToast = (message, variant = 'success') => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast({ ...toast, show: false }), 3000);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleMultiSelectChange = (e) => {
    const options = Array.from(e.target.selectedOptions).map((opt) => opt.value);
    setForm({ ...form, activities: options });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      policyTypes: checked
        ? [...prevForm.policyTypes, value]
        : prevForm.policyTypes.filter((p) => p !== value),
    }));
  };
// const downloadPolicy = async (policy) => {
//   const userId = userData?.["cognito:username"];
//   try {
//     const region = getUserRegion();
//     const res = await axios.get(
//       `https://aftyp395de.execute-api.ap-southeast-2.amazonaws.com/prod/api/generate-policy/download/${policy.id}`,
//       {
//         headers: {
//           Region: region,
//           UserId: userId
//         },
//         responseType: 'blob'
//       }
//     );

//     // Create a Blob with correct MIME type for DOCX
//     const blob = new Blob([res.data], {
//       type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
//     });

//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;

//     // âœ… Set .docx extension instead of .txt
//     link.setAttribute('download', `${policy.name.replace(/\s+/g, '_')}.docx`);

//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//     window.URL.revokeObjectURL(url);

//     await logActivity(`Downloaded ${policy.name}`, "primary");

//   } catch (error) {
//     showToast('Error downloading policy', 'danger');
//   }
// };
// const downloadPolicy = async (policy) => {
//   const userId = userData?.["cognito:username"];

//   try {
//     const region = getUserRegion();

//     const res = await axios.get(
//       `https://aftyp395de.execute-api.ap-southeast-2.amazonaws.com/prod/api/generate-policy/download/${policy.id}`,
//       {
//         headers: {
//           Region: region,
//           UserId: userId
//         },
//         responseType: "blob"
//       }
//     );

//     const url = window.URL.createObjectURL(res.data);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = `${policy.name.replace(/\s+/g, "_")}.docx`;

//     document.body.appendChild(link);
//     link.click();

//     link.remove();
//     window.URL.revokeObjectURL(url);

//   } catch (error) {
//     showToast("Error downloading policy", "danger");
//   }
// };


// const downloadPolicy = async (policy) => {
//   const userId = userData?.["cognito:username"];

//   try {
//     const region = getUserRegion();

//     const res = await axios.get(
//       `https://aftyp395de.execute-api.ap-southeast-2.amazonaws.com/prod/api/generate-policy/download/${policy.id}`,
//       {
//         headers: {
//           Region: region,
//           UserId: userId,
//         },
//         responseType: "blob",
//       }
//     );

//     // âœ… CRITICAL FIX: Wrap response in proper Blob
//     const blob = new Blob([res.data], {
//       type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
//     });

//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = `${policy.name.replace(/\s+/g, "_")}.docx`;

//     document.body.appendChild(link);
//     link.click();

//     link.remove();
//     window.URL.revokeObjectURL(url);

//   } catch (error) {
//     showToast("Error downloading policy", "danger");
//   }
// };

const handleGenerate = async () => {
    const userId =organizationId;
  console.log("ðŸ“¨ organizationId:", userId);
  console.log("ðŸ”„ Starting policy generation process...");
  console.log("ðŸ“‹ Current form data:", form);

  if (!form.orgName || !form.industry || !form.location || form.policyTypes.length === 0) {
    console.warn("âš ï¸ Missing required fields");
    showToast('Please fill all required fields.', 'danger');
    return;
  }

  // Validate custom industry if "Other" is selected
  if (form.industry === 'Other' && !form.customIndustry.trim()) {
    showToast('Please specify your industry.', 'danger');
    return;
  }

  setLoading(true);
  try {
    const payload = {
      ...form,
      // Use customIndustry if "Other" is selected
      industry: form.industry === 'Other' ? form.customIndustry : form.industry
    };
    const headers = {
      organizationId:organizationId,
      Region: getUserRegion(),
    };

    console.log("ðŸ“¤ Sending POST request with payload:", payload);
    console.log("ðŸ“¨ Headers:", headers);

    const res = await axios.post(
      'https://8ha9e2oh9g.execute-api.ap-southeast-2.amazonaws.com/prod/api/generate-policy/create',
      payload,
      { headers }
    );

    console.log("âœ… Response received:", res.data);
    setGeneratedPolicies(res.data.generated || []);
    showToast('Policies generated!');
    await logActivity("Generated policies using DPDP tool", "success");
    logToAccessLogs?.({
  action:      'Policy Generated',
  severity:    'success',
  description: `Generated ${res.data.generated?.length ?? 0} policies for ${form.orgName} (${form.industry})`,});


  } catch (err) {
    console.error("âŒ Error generating policies:", err);
    showToast('Error generating policies', 'danger');
  } finally {
    console.log("ðŸ Finished policy generation request.");
    setLoading(false);
  }
};



const logActivity = async (message, badge = "info") => {
  const userId = userData?.["cognito:username"];
  try { await axios.post(
         "https://ugat9qq1mj.execute-api.ap-southeast-2.amazonaws.com/prod/api/dpdp/activities/create",
         {
           message,
           badge,
           timestamp: new Date().toISOString()
         },
         {
           headers: {
             Region: getUserRegion(),
             organizationId: organizationId
           }
      });
     } catch (err) {
    console.warn("Failed to log activity:", err.message);
  }
};
const downloadPolicy = async (policy) => {
  const userId =organizationId;
  try {
    const region = getUserRegion();
    const res = await axios.get(
      `https://aftyp395de.execute-api.ap-southeast-2.amazonaws.com/prod/api/generate-policy/download/${policy.id}`,
      {
        headers: {
          Region: region,
           organizationId:organizationId
        },
        responseType: 'blob'
      }
    );
 
    // Create a Blob with correct MIME type for DOCX
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    });
 
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
 
    // âœ… Set .docx extension instead of .txt
    link.setAttribute('download', `${policy.name.replace(/\s+/g, '_')}.docx`);
 
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
 
    await logActivity(`Downloaded ${policy.name}`, "primary");
    logToAccessLogs?.({
  action:      'Policy Downloaded',
  severity:    'info',
  description: `Downloaded policy: ${policy.name}`,});
 
  } catch (error) {
    showToast('Error downloading policy', 'danger');
  }
};
 

  return (
    <Row>
      <Col lg={8}>
        <Card className="mb-4">
          <Card.Header>
            <h5 className="mb-0">Generate DPDP-Compliant Policies</h5>
          </Card.Header>
          <Card.Body>
            <Form>
             <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Organization Name</Form.Label>
      <Form.Control
        type="text"
        name="orgName"
        placeholder="Enter your company name"
        value={form.orgName}
        onChange={handleChange}
      />
    </Form.Group>
  </Col>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Industry Sector</Form.Label>
      <Form.Select
        name="industry"
        value={form.industry}
        onChange={handleChange}
      >
        <option value="">Select Industry</option>
        <option>Financial Services</option>
        <option>Healthcare</option>
        <option>E-commerce</option>
        <option>Education</option>
        <option>Technology</option>
        <option>Manufacturing</option>
        <option value="Other">Other</option>
      </Form.Select>
    </Form.Group>
    
    {/* âœ… Conditional field for custom industry - stays in same column */}
    {form.industry === 'Other' && (
      <Form.Group className="mb-3">
        <Form.Label>Specify Industry</Form.Label>
        <Form.Control
          type="text"
          name="customIndustry"
          placeholder="Enter your industry"
          value={form.customIndustry}
          onChange={handleChange}
        />
      </Form.Group>
    )}
  </Col>
</Row>


              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Primary Business Location</Form.Label>
                    <Form.Select
                      name="location"
                      value={form.location}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option>India</option>
                      <option>India + International Operations</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
<Form.Group className="mb-3">
  <Form.Label>Data Processing Activities</Form.Label>
  <Select
    isMulti
    name="activities"
    options={ACTIVITY_OPTIONS}
    value={ACTIVITY_OPTIONS.filter(opt => form.activities.includes(opt.value))}
    onChange={(selected) => {
      setForm({ ...form, activities: selected.map(s => s.value) });
    }}
  />
</Form.Group>



                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Policy Type</Form.Label>
                    <div>
                      {['Privacy Policy', 'Cookie Policy', 'Data Retention Policy', 'Consent Notice', 'DPAR Form'].map((type) => (
                        <Form.Check
                          key={type}
                          type="checkbox"
                          label={type}
                          value={type}
                          checked={form.policyTypes.includes(type)}
                          onChange={handleCheckboxChange}
                          className="mb-2"
                        />
                      ))}
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex gap-2">
                <Button variant="primary" onClick={handleGenerate} disabled={loading}>
                  {loading && <Spinner animation="border" size="sm" className="me-2" />}
                  Generate Policies
                </Button>
                <Button variant="outline-danger" onClick={handleReset}>Reset</Button>

               <Button
  variant="outline-secondary"
  onClick={() => handlePreview()}
  disabled={form.policyTypes.length === 0}
>
  Preview Sample
</Button>

              </div>
            </Form>
          </Card.Body>
        </Card>
      </Col>

      <Col lg={4}>
        <Card>
          <Card.Header>
            <h6 className="mb-0">Generated Policies</h6>
          </Card.Header>
          <Card.Body>
            {generatedPolicies.length === 0 ? (
              <p>No policies generated yet.</p>
            ) : (
              <div className="list-group list-group-flush">
                {generatedPolicies.map((policy, idx) => (
                  <div
                    className="list-group-item d-flex justify-content-between align-items-center"
                    key={idx}
                  >
                    {policy.name}
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => downloadPolicy(policy)}

                    >
                      <FaFileDownload />
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>

      {/* Toast Notification */}
      <ToastContainer position="bottom-end" className="p-3">
        <Toast show={toast.show} bg={toast.variant}>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Row>
  );
};

export default PolicyGeneratorTab;